// The review above the packet: what is in it, what it rests on, what it cannot
// say, and whether this exact version has been looked at.
//
// It is the one part of the send preview that is not the packet, so it hides
// itself from print. Everything on it is decided in sendPreview.js; this
// component chooses no wording of its own about the household.

const fmtDate = iso => new Date(iso).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });

export default function SendPanel({
  prepared,
  statements,
  period,
  sections,
  onToggle,
  boards,
  limitations,
  reviewed,
  reviewedCurrent,
  canReview,
  onReview,
  onPrint,
  onBack,
}) {
  const blocking = limitations.filter(l => l.blocking);
  const included = sections.filter(s => s.on && s.available);

  return (
    <section className="asmt-send-panel" aria-label="What will be sent">
      <div className="asmt-send-head">
        <h2>What will be sent</h2>
        <button type="button" className="asmt-btn is-ghost" onClick={onBack}>Back to preparation</button>
      </div>

      <dl className="asmt-send-facts">
        <dt>Prepared</dt>
        <dd>{prepared}</dd>
        <dt>Statements</dt>
        <dd>{statements || 'None analyzed'}</dd>
        <dt>Goals use figures from</dt>
        <dd>{period || 'This year'}</dd>
        <dt>Boards</dt>
        <dd>
          {boards.some(b => b.drawn)
            ? boards.filter(b => b.drawn).map(b => b.title).join('; ')
            : 'None drawn, so none in the packet'}
        </dd>
      </dl>

      <div className="asmt-send-sections" role="group" aria-label="Sections in the packet">
        <h3>{included.length} {included.length === 1 ? 'section' : 'sections'}</h3>
        {sections.map(s => (
          <label key={s.id} className={`asmt-send-item${s.available ? '' : ' is-absent'}`}>
            <input
              type="checkbox"
              checked={s.on}
              disabled={!s.available}
              onChange={e => onToggle(s.id, e.target.checked)}
            />
            <span>{s.label}</span>
            {!s.available && <span className="asmt-send-absent">not in this report</span>}
          </label>
        ))}
      </div>

      {limitations.length > 0 && (
        <div className="asmt-send-limits">
          <h3>What this packet cannot say</h3>
          <ul>
            {limitations.map(l => (
              <li key={l.key} className={l.blocking ? 'is-blocking' : ''}>{l.text}</li>
            ))}
          </ul>
        </div>
      )}

      <div className="asmt-send-review">
        {reviewed && reviewedCurrent && (
          <span className="asmt-send-status is-ok" role="status">Reviewed {fmtDate(reviewed.at)}. This is the version that prints.</span>
        )}
        {reviewed && !reviewedCurrent && (
          <span className="asmt-send-status is-warn" role="status">Changed since it was reviewed on {fmtDate(reviewed.at)}. Review it again before printing.</span>
        )}
        {!reviewed && (
          <span className="asmt-send-status" role="status">Not yet reviewed. Read it through, then mark it reviewed to print.</span>
        )}
        <button type="button" className="asmt-btn is-ghost" onClick={onReview} disabled={!canReview}>
          {reviewed && reviewedCurrent ? 'Reviewed' : 'Mark as reviewed'}
        </button>
        <button type="button" className="asmt-btn" onClick={onPrint} disabled={!(reviewed && reviewedCurrent)}>
          Print / Save PDF
        </button>
        {blocking.length > 0 && (
          <span className="asmt-send-blocked">Resolve the item{blocking.length === 1 ? '' : 's'} above first.</span>
        )}
      </div>
    </section>
  );
}
